import { InfoBlock } from "../InfoBlock/InfoBlock";
import {
  HeadText,
  StudiesBlock,
  StudiesBlockAround,
  StudiesContainer
} from "./styled";
import {useStudies} from "./useStudies";
import { Link } from "react-router-dom";
import {schoolArr} from "./ourSchoolObj";
import { Loader } from "../Loader/Loader";

export const Studies = () => {
  const {studies, isLoading} = useStudies()

  return (
    <StudiesContainer>
      <HeadText>Наша школа</HeadText>
      <StudiesBlockAround>
      {Object.entries(schoolArr).map(([key, value]) => {
        return <Link key={key} to={`/ourschool/${value.link}`}> <InfoBlock name={value.title} img={value.photo}/></Link>
      })}
      </StudiesBlockAround>
      <HeadText>Студии и кружки</HeadText>
      <StudiesBlock>
        {isLoading || !studies ? (
          <Loader compact />
        ) : (
          <StudiesBlockAround>
            {studies.map((value: any) => (
              <Link key={value.slug} to={`/class/${value.slug}`}>
                <InfoBlock name={value.title} img={value.image}/>
              </Link>
            ))}
          </StudiesBlockAround>
        )}
      </StudiesBlock>
    </StudiesContainer>
  );
};
